<template>
  <v-layout column>

    <h2>Seguro de saúde</h2>
    <h3 class="mb-4 text-secondary">Health Insurance</h3>

    <h3>TEM SEGURO SAÚDE?/DOES YOUR CHILD HAVE HEALTH INSURANCE?</h3>
    <v-radio-group v-model="resource.form.has_health_insurance" row>
      <v-radio label="SIM/YES" :value="true"></v-radio>
      <v-radio label="NÃO/NO" :value="false"></v-radio>
    </v-radio-group>

    <v-layout row wrap>
      <v-flex d-flex xs12 sm6 md6>
        <v-text-field
          outline
          v-model="resource.form.insurance_provider_name"
          :disabled="!resource.form.has_health_insurance"
          :background-color="resource.form.has_health_insurance ? '' : '#ccc'"
          :rules="resource.form.has_health_insurance ? required : []"
          label="QUAL? / NAME OF INSURANCE PROVIDER?"
        />
      </v-flex>

      <v-flex d-flex xs12 sm6 md6>
        <v-text-field
          outline
          v-model="resource.form.insurance_policy_holder"
          :disabled="!resource.form.has_health_insurance"
          :background-color="resource.form.has_health_insurance ? '' : '#ccc'"
          :rules="resource.form.has_health_insurance ? required : []"
          label="TITULAR / POLICY HOLDER."
        />
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex d-flex xs12 sm6 md6>
        <v-text-field
          outline
          v-model="resource.form.insurance_id_card"
          :disabled="!resource.form.has_health_insurance"
          :background-color="resource.form.has_health_insurance ? '' : '#ccc'"
          :rules="resource.form.has_health_insurance ? required : []"
          label="NÚMERO DA CARTEIRINHA/ ID CARD"
        />
      </v-flex>

      <v-flex d-flex xs12 sm6 md6>
        <v-text-field
          outline
          v-model="due_date"
          :disabled="!resource.form.has_health_insurance"
          :background-color="resource.form.has_health_insurance ? '' : '#ccc'"
          :rules="resource.form.has_health_insurance ? [required, date] : []"
          mask="##/##/####" return-masked-value placeholder="dd/mm/yyyy"
          label="VALIDADE/ DUE DATE"
        />
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import { formatDateToPtBR, formatDateToDbFormat } from '@/helpers/formatDbDate'
import { date as datePattern } from '@/helpers/regex'

/**
 * @group Form
 * Componente de form para dados de Seguro de Saúde do estudante
 */
export default {
  name: 'FormHealthInsurance',

  data: () => ({
    required: [v => !!v || 'Campo obrigatório/Field is required'],
    date: value => {
      return datePattern.test(value) || 'Data inválida/Invalid date'
    }
  }),

  inject: ['resource'],

  computed: {
    resource () {
      return this.resource
    },
    due_date: {
      get () {
        return formatDateToPtBR(this.resource.form.due_date)
      },
      set (newValue) {
        this.resource.form.due_date = formatDateToDbFormat(newValue)
      }
    }
  },

  methods: {
    validateForm () {
      return this.$refs.form.validate()
    }
  }
}
</script>
